import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { successColor, dangerColor } from "assets/jss/material-dashboard-pro-react.js";

const useStyles = makeStyles({
  root: {
    width: "100%"
  },
  container: {
    maxHeight: 440
  },
  legend: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    padding: "12px 16px"
  }
});

const attendanceStatusBackgroundColor = {
  success: successColor[6],
  danger: dangerColor[6]
};

const ActiveTable = props => {
  const classes = useStyles();
  const { data, attendanceStatusByFicha, attendanceDetailByFicha, attendanceDate } = props;
  const dateLabel = attendanceDate ? attendanceDate.format("DD/MM/YYYY") : "";
  const attendanceStatusLegend = [
    { value: "success", label: `Marcó asistencia el ${dateLabel}` },
    { value: "danger", label: `Con turno asignado y sin marcar el ${dateLabel}` }
  ];
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [attendanceStatusFilters, setAttendanceStatusFilters] = React.useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleClickLegendItem = value => {
    setAttendanceStatusFilters(
      attendanceStatusFilters.includes(value)
        ? attendanceStatusFilters.filter(filterValue => filterValue !== value)
        : [...attendanceStatusFilters, value]
    );
    setPage(0);
  };

  const filteredData = attendanceStatusFilters.length > 0
    ? data.filter(row => attendanceStatusByFicha && attendanceStatusFilters.includes(attendanceStatusByFicha[row.id]))
    : data;

  return (
    <Paper className={classes.root}>
      {attendanceStatusByFicha &&
        <div className={classes.legend}>
          {attendanceStatusLegend.map(item => {
            const isSelected = attendanceStatusFilters.includes(item.value);
            return (
              <Chip
                key={item.value}
                label={item.label}
                onClick={() => handleClickLegendItem(item.value)}
                variant={isSelected ? "default" : "outlined"}
                style={{
                  backgroundColor: isSelected ? attendanceStatusBackgroundColor[item.value] : "transparent",
                  borderColor: attendanceStatusBackgroundColor[item.value],
                  cursor: "pointer"
                }}
              />
            );
          })}
        </div>
      }
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Cargo</TableCell>
              <TableCell align="center">{`Estado ${props.isTENS ? "TENS" : ""}`}</TableCell>
              {attendanceDetailByFicha && <TableCell align="center">Marcaje</TableCell>}
              <TableCell align="center">{`Estado vigencia`}</TableCell>
              {props.isTENS && <TableCell align="center">Observación</TableCell>}
              {!props.isTENS && <TableCell align="center">Acciones</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
              const attendanceStatus = attendanceStatusByFicha ? attendanceStatusByFicha[row.id] : null;
              const rowStyle = attendanceStatus ? { backgroundColor: attendanceStatusBackgroundColor[attendanceStatus] } : {};

              return (
                <TableRow key={row.id} align="center" style={rowStyle}>
                  <TableCell align="center">
                    {`${row.nombres} ${row.apellido_paterno} ${row.apellido_materno}`}
                  </TableCell>
                  <TableCell align="center">{row.id_cargo?.nombre_corto || ""} </TableCell>
                  <TableCell align="center">{props.isTENS ? row.status_candidato : row.status}</TableCell>
                  {attendanceDetailByFicha &&
                    <TableCell align="center">
                      {attendanceDetailByFicha[row.id]?.nombre &&
                        <>
                          {attendanceDetailByFicha[row.id].nombre}
                          {attendanceDetailByFicha[row.id].distanciaKm != null &&
                            <div>{`${attendanceDetailByFicha[row.id].distanciaKm.toFixed(1)} km`}</div>
                          }
                        </>
                      }
                    </TableCell>
                  }
                  <TableCell align="center">{row.estado_vigencia}</TableCell>
                   {props.isTENS &&<TableCell align="center">{row.observacion}</TableCell>}
                   {!props.isTENS &&<TableCell align="center">
                    <Link to={`/admin/personalfile/manage/${row.id}`}>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ textTransform: "none" }}
                      >
                        Detalle
                      </Button>
                    </Link>
                  </TableCell>}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: { "aria-label": "Filas por página" },
          native: false
        }}
        labelRowsPerPage={"Filas por página"}
        nextIconButtonText={"Siguiente"}
        backIconButtonText={"Atrás"}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to === -1 ? count : to} de ${
            count !== -1 ? count : `más que ${to}`
          }`
        }
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default ActiveTable;
